import { axiosInstance } from "@/config/axiosInstance";
import type { BreakView } from "@/components/break/types";

//  ****** GET CURRENT ADMIN ******
export const getCurrentAdmin = (adminKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      foundAdmin?: {
        _id: string;
        email: string;
        name: string;
        phone: string;
      };
      error?: string;
    }>("/admin/current", {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL EMPLOYEES ******
export const getAllEmployees = (adminKey: string) =>
  axiosInstance
    .post<{
      success: boolean;
      employees: {
        name: string;
        _id: string;
        email: string;
        phone: string;
        permissions?: {
          1: string[];
          2: string[];
          3: string[];
        };
        blocked: boolean;
      }[];
    }>(
      "/admin/employees",
      {},
      {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

// ? Fetch Employee Action

export const fetchSingleEmployee = (adminKey: string) => (empId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      employee: {
        _id: string;
        email: string;
        name: string;
        blocked: boolean;
        holidayList?: {
          name: string;
          _id: string;
          holidays: {
            holidayName: string;
            date: string;
            description: string;
          }[];
        };
        address: string;
        phone: string;
        emergencyContactNumber: string;
        role: string;
        leaveApprover: string;
        loanApprover: string;
        allowanceApprover: string;
        bloodGroup: string;
        employeeCode: string;
        panNumber: string;
        pfNumber: string;
        paidAmount: number;
        grossSalary: number;
        travellingExpenses: number;
        otherExpenses: number;
        offerLetter: string;
        paidLeavesRemaining: number;
        paidLeavesTotal: number;
        performancePoints: number;
        photo: string;
        promotionLetters: string[];
        documents?: {
          doc: string;
          url: string;
        }[];
        otherDetails: string;
        familyDetails: string;
      };
    }>(`/employee/fetch/${empId}`, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL HOLIDAYS LIST ******
export const getAllHolidayList = (adminKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      foundLists: {
        name: string;
        _id: string;
        holidays: {
          holidayName: string;
          description: string;
          date: Date;
        }[];
      }[];
    }>("/holiday/all", {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET Single Holiday LIST ******
export const getOneHolidayList =
  (adminKey: string) => (holidayListId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        foundList: {
          name: string;
          _id: string;
          holidays: {
            holidayName: string;
            description: string;
            date: Date;
          }[];
          halfDays?: {
            dayOfWeek: number;
            minimumHours: number;
          }[];
        };
      }>(`/holiday/one/${holidayListId}`, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET EMPLOYEE CHECKINS ******
export const getEmployeeCheckins = (adminKey: string) => (empId: string) =>
  axiosInstance
    .post<{
      success: boolean;
      error?: string;
      checkins?: {
        mode: string;
        createdAtIST: string | Date;
        createdAt: string | Date;
        _id: string;
        employee: {
          name: string;
          email: string;
        };
        workDoneToday: string;
        attachments?: {
          doc: string;
          url: string;
        }[];
      }[];
    }>(
      `/admin/checkins/${empId}`,
      {},
      {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET ALL LEAVE APPLICATIONS ******
export const getAllLeaveApplications = (adminKey: string) => (status: string) =>
  axiosInstance
    .post<{
      success: boolean;
      error?: string;
      LeaveApplication?: {
        _id: string;
        leaveType: string;
        reason: string;
        startDate: string | Date;
        endDate: string | Date;
        status: string;
        employee: {
          name: string;
          email: string;
        };
        createdAt: Date | string;
        attachment: string;
        isPaid: boolean;
        isHalfDay: boolean;
      }[];
    }>(
      `/leave/admin/fetch/all`,
      { status },
      {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET ALL LEADS ******
export const fetchAllLeads =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; status?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        leads: {
          name: string;
          phone: string;
          status: string;
          originalStatus: string;
          _id: string;
          createdBy?: {
            _id: string;
            name: string;
            email: string;
          };
          alloted: boolean;
          allotedAt?: string | Date;
          allotedTo?: {
            name: string;
            email: string;
            _id: string;
          };
          broker: string;
          createdAt: string | Date;
        }[];
      }>(`/lead/fetch/admin`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL Allowance Requests Action ******
export const getAllAllowanceRequests = (adminKey: string) => (status: string) =>
  axiosInstance
    .post<{
      success: boolean;
      error?: string;
      Allowances?: {
        _id: string;
        reason: string;
        amountRequested: number;
        status: string;
        employee: {
          name: string;
          email: string;
        };
        attachment: string;
        createdAt: Date | string;
      }[];
    }>(
      `/allowance/admin/fetch/all`,
      { status },
      {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET ALL Loan Requests ******
export const getAllLoanRequestsForAdmin =
  (adminKey: string) => (status: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        loans?: {
          _id: string;
          totalAmountRequested: number;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(
        `/loan/admin/fetch/all`,
        { status },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL Loan Requests ******
export const getAllLoanRequestsOfEmpByAdmin =
  (adminKey: string) => (status?: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        loans?: {
          _id: string;
          totalAmountRequested: number;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(
        `/loan/admin/fetch/created`,
        { status },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET Single Loan Request ******
export const getSingleLoanRequest = (adminKey: string) => (loanId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      loan: {
        _id: string;
        status: string;
        interestRate: number;
        employeeId: {
          name: string;
          email: string;
          _id: string;
        };
        totalAmountRequested: number;
        totalAmountApproved: number;
        totalRepaymentAmount: number;
        remainingBalance: number;
        repaymentSchedule?: {
          _id: string;
          amount: number;
          createdAt: string | Date;
          dueDate: string | Date;
          paidAmount: number;
          status: string;
        }[];
      };
    }>(`/loan/admin/one/${loanId}`, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET Loan Repayment Requests For Admin ******
export const getLoanRepaymentRequestsForAdmin =
  (adminKey: string) => (loanId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        requests: {
          _id: string;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          attachment: string;
          amount: number;
          createdAt: string | Date;
          createdAtIST: string | Date;
        }[];
      }>(`/loan/admin/requests/${loanId}`, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ATTENDANCE REQUESTS ******
export const fetchAllAttendanceRequestsForAdmin =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; status?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        requests: {
          notes: string;
          status: string;
          _id: string;
          createdAt: string | Date;
          date: string | Date;
          employee: {
            name: string;
          };
        }[];
      }>(`/attendance/request/all/admin`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL PERFORMANCE LOGS OF A EMPLOYEE ******
export const fetchAllPerformanceLogsOfEmployeeForAdmin =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        log: {
          _id: string;
          reasonPositive: string;
          reasonNegative: string;
          deduction: number;
          addition: number;
          createdAt: string | Date;
          date: string | Date;
        }[];
      }>(`/performance/logs/admin/all`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET AVERAGE SCORE OF A EMPLOYEE ******
export const fetchAggregatePerformancePointsForEmployee =
  (key: string) => (data: { month?: string; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        aggregate: number;
        average: number;
      }>(`/performance/report/calculate-aggregate`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL Timesheets By Month For Admin ******
export const fetchAllTimesheetsByMonthForAdmin =
  (key: string) => (data: { monthName: string; year: number }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        sheets: {
          _id: string;
          month: string;
          year: number;
          present: number;
          absent: number;
          paidLeave: number;
          unpaidLeave: number;
          createdAt: string | Date;
          salaryGenerated: boolean;
          createdFromCSV: boolean;
          employee: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/salary/fetch-datesheet`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Single Timesheet By Id For Admin ******
export const fetchSingleTimesheetByIdForAdmin =
  (key: string) => (sheetId: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        sheet: {
          _id: string;
          month: string;
          year: number;
          present: number;
          absent: number;
          paidLeave: number;
          unpaidLeave: number;
          halfDay: number;
          createdAt: string | Date;
          holiday: number;
          components: {
            amount: number;
            type: string;
            name: string;
          }[];
          employee: {
            _id: string;
            name: string;
            grossSalary: number;
          };
        };
      }>(
        `/salary/fetch-datesheet-admin/${sheetId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${key}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL PERFORMANCE LOGS OF A EMPLOYEE ******
export const fetchAllPerformanceReportOfEmployeeForAdmin =
  (key: string) =>
  (data: {
    startdate: Date;
    enddate: Date;
    employee: string;
    published: boolean;
  }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        performanceReports: {
          _id: string;
          reasonPositive: string;
          reasonNegative: string;
          deduction: number;
          createdAt: string | Date;
          date: string | Date;
        }[];
      }>(`/performance/report/admin/all`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Single Lead log ******
export const fetchSingleLeadLogForAdmin = (key: string) => (leadId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      error?: string;
      logs: {
        _id: string;
        beforeStatus: string;
        comments: string;
        afterStatus: string;
        createdAt: string | Date;
        createdBy?: {
          _id: string;
          name: string;
        };
      }[];
    }>(`/lead/admin/logs/${leadId}`, {
      headers: {
        authorization: `Bearer ${key}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL SALARY OF A EMPLOYEE ******
export const fetchAllSalaryOfEmployeeForAdmin =
  (key: string) => (data: { start: Date; end: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        salary: {
          _id: string;
          approved: boolean;
          employee: {
            _id: string;
            name: string;
            email: string;
          };
          createdAt: string | Date;
          netPay: number;
          totalDeductions: number;
          totalEarnings: number;
          notes: string;
          period: {
            start: string | Date;
            end: string | Date;
          };
          components: {
            type: string;
            name: string;
            amount: number;
            _id: string;
            description: string;
          }[];
        }[];
      }>(
        `/salary/fetch`,
        {
          period: data,
        },
        {
          headers: {
            authorization: `Bearer ${key}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

export const getAllAnnouncementsForAdmin =
  (adminKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        announcements: {
          createdAt: string;
          description: string;
          files: string[];
          title: string;
          _id: string;
        }[];
      }>(`/announcement/admin/get/all`, dates, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employee Attendance for Admin ******
export const getAttendanceOfEmployeeForAdmin =
  (adminKey: string) =>
  (dates: { startdate: Date; enddate: Date; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance?: {
          _id: string;
          createdAt: Date | string;
          status: string;
          date: string | Date;
          hoursWorked: number;
          adminComment: {
            time: string;
            comment: string;
          }[];
          checkin: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
          checkout: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
        }[];
      }>(`/attendance/fetch/admin`, dates, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const getAttendanceOfAllEmployees =
  (adminKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance?: {
          _id: string;
          createdAt: Date | string;
          employee: {
            _id: string;
            name: string;
          };
          status: string;
          date: string | Date;
          hoursWorked: number;
          adminComment: {
            time: string;
            comment: string;
          }[];
          checkin: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
            isLate: boolean;
          }[];
          checkout: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
        }[];
      }>(`/attendance/fetch/admin/all`, dates, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employee Attendance ******
export const getAttendanceOfEmpByMonthYearForAdmin =
  (adminKey: string) =>
  (data: { monthName: string; year: number; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance?: {
          _id: string;
          createdAt: Date | string;
          status: string;
          date: string | Date;
          checkin: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
          checkout: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
          hoursWorked: number;
        }[];
      }>(`/attendance/fetch/admin/month`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employees Checkins ******
export const getCheckinsOfEmployeesDayWise =
  (adminKey: string) => (data: { date: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        checkins?: {
          _id: string;
          createdAt: Date | string;
          employee: {
            name: string;
            _id: string;
          };
          mode: string;
        }[];
      }>(`/attendance/fetch/admin/checkins`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Get All Loans of a particular employee by admin
export const getAllLoansOfEmployeeByAdmin =
  (adminKey: string) => (need: { status: string; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        loans?: {
          _id: string;
          totalAmountRequested: number;
          totalAmountApproved: number;
          remainingBalance: number;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(`/loan/fetch/admin/employee/loans`, need, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Get All attendance request of a particular employee by admin
export const getAttendanceRequestsOfEmpByAdmin =
  (adminKey: string) => (need: { status: string; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        requests?: {
          _id: string;
          notes: string;
          date: string;
          status: string;
          employee: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(`/attendance/fetch/admin/employee/request`, need, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Get All attendance request of a particular employee by admin
export const getAttendanceCommentsByDateAsAdmin =
  (adminKey: string) => (need: { date: string | Date; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        comments?: {
          _id: string;
          date: string;
          adminComment: string[];
          employee: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(`/attendance/get-comment-date`, need, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET DATEWISE LEADS ******
export const fetchLeadsDateWiseAdmin =
  (key: string) =>
  (data: { employee: string; startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        reports: {
          alloted: number;
          attempted: number;
          open: number;
          closed: {
            success: number;
            failed: number;
          };
        };
      }>(`/lead/fetch-reports/admin`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET DATEWISE LEADS of ALL EMPLOYEES ******
export const fetchLeadsDateWiseOfAllEmployeeForAdmin =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        reports: {
          [key: string]: {
            alloted: number;
            attempted: number;
            open: number;
            closed: {
              success: number;
              failed: number;
            };
          };
        }[];
      }>(`/lead/fetch-reports-all`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET LEADS of ALL EMPLOYEES ******
export const fetchLeadsDataOfAllEmployeeForAdmin =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        reports: {
          [key: string]: {
            alloted: boolean;
            allotedAt: string;
            broker: string;
            createdAt: string;
            date: string;
            status: string;
            statusChanged: boolean;
            _id: string;
          }[];
        }[];
      }>(`/lead/fetch-leads-list`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ATTENDANCE CHANGE LOGS ******
export const getAttendanceChangeLogsForAdmin =
  (key: string) =>
  (data: {
    employee?: string;
    startDate?: Date | string;
    endDate?: Date | string;
    page?: number;
    limit?: number;
  }) =>
    axiosInstance
      .post<{
        success: boolean;
        logs: {
          _id: string;
          attendance: string;
          employee: {
            _id: string;
            name: string;
            email: string;
          };
          employeeName: string;
          admin: {
            _id: string;
            name: string;
            email: string;
          };
          adminName: string;
          adminEmail: string;
          previousStatus: string;
          newStatus: string;
          attendanceDate: string;
          reason: string;
          acknowledgedChange: boolean;
          createdAtIST: string;
          createdAt: string;
        }[];
        pagination: {
          total: number;
          page: number;
          limit: number;
          totalPages: number;
        };
        error?: string;
      }>(`/attendance/change-logs`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Breaks of every managed employee that started on a given IST day
export const getBreaksOfEmployeesDayWise =
  (adminKey: string) => (data: { date: Date }) =>
    axiosInstance
      .post<{ success: boolean; error?: string; breaks: BreakView[] }>(
        `/break/admin/day`,
        data,
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Recent breaks of one managed employee (server default: last 30 days)
export const getEmployeeBreaks =
  (adminKey: string) =>
  (empId: string, range?: { startDate?: Date; endDate?: Date }) =>
    axiosInstance
      .post<{ success: boolean; error?: string; breaks: BreakView[] }>(
        `/break/admin/employee/${empId}`,
        range ?? {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
